<template>
  <div>
    <vue-apex-charts :height="height || 400" type="donut" :options="options" :series="series"/>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: { VueApexCharts },
  props: ["x", "y", "height", "format", "tooltip"],
  data() {
      return {
        options: {
          labels: this.x,
          dataLabels: {
            enabled: false,
            formatter: this.format || (v => v),
          },
          legend: {
              position: "top",
          },
        },
        series: this.y
      }
  }
}
</script>